<template>
  <div>
    <el-button-group v-show="!disabled" style="padding-bottom:10px;">
      <el-button
        @click="fromLoad('add')"
        type="success"
        size="small"
      >{{$l('btn_schedule_add')||'新增里程碑'}}</el-button>
    </el-button-group>
    <el-table
      ref="table"
      :data="tableData"
      size="small"
      :height="height"
      style="width: 100%"
      :header-cell-style="{background:'#eef1f6',color:'#606266'}"
    >
      <el-table-column
        :label="$l('table_head_operation'||'操作')"
        width="130"
        header-align="center"
        v-if="!disabled"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            style="padding:5px;"
            icon="el-icon-edit-outline"
            @click="fromLoad('edit',scope.row.scheduleCode)"
          />
          <el-button
            size="mini"
            style="padding:5px;"
            type="danger"
            @click="delRow([scope.row.scheduleCode])"
            icon="el-icon-delete"
          ></el-button>
          <el-button
            icon="el-icon-check"
            v-if="scope.row.isChecked === 'N'"
            size="mini"
            style="padding:5px;"
            type="success"
            @click="confirm(scope.row.scheduleCode,'Y')"
          ></el-button>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        header-row-style
        prop="milestonesTypeText"
        :label="$l('label_milestone_type')||'里程碑'"
      />
      <el-table-column
              :show-overflow-tooltip="true"
              align="left"
              header-align="left"
              header-row-style
              prop="milestonesDesc"
              :label="$l('label_milestone_desc')||'节点说明'"
      />
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="beginTime"
        :label="$l('label_milestone_begin')||'开始日期'"
        width="150"
      />
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="endTime"
        :label="$l('label_milestone_end')||'结束日期'"
        width="150"
      />
      <!-- <el-table-column
        align="left"
        header-align="left"
        prop="isCheckedText"
        label="确认节点"
        width="80"
      />
      <el-table-column
        align="left"
        header-align="left"
        prop="milestonesStatusText"
        label="节点状态"
        width="80"
      />-->
    </el-table>
    <!--分页-->
    <!-- <template> -->
    <!--      <el-pagination-->
    <!--        background-->
    <!--        :current-page="page.curPage"-->
    <!--        :page-size="page.pageSize"-->
    <!--        :total="page.total"-->
    <!--        @size-change="sizeChange"-->
    <!--        @current-change="currentChange"-->
    <!--        layout="total, sizes, prev, pager, next, jumper, ->, slot"-->
    <!--      ></el-pagination>-->
    <!-- </template> -->
    <!--编辑弹框-->
    <el-dialog
      ref="formDialog"
      :title="formOption.title"
      :visible.sync="formOption.dialogFormVisible"
      :before-close="cancel"
      :close-on-click-modal="false"
      width="600px"
    >
      <page-detail ref="form" :prjCode="params.prjCode" @success="saveSuccess"></page-detail>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">{{$l('btn_cancel') || '取消'}}</el-button>
        <el-button
          type="primary"
          @click="save"
          size="small"
          v-show="formOption.dialogSaveBtnVisible"
        >{{$l('btn_save') || '保存'}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  components: {
    PageDetail: () => import("./components/detail/index"),
  },
  props: {
    params: {
      default: null,
      type: Object,
    },
    disabled: {
      default: true,
      type: Boolean,
    },
    autoLoad: {
      default: false,
      type: Boolean,
    },
    height: {
      default: 272,
      type: Number,
    },
  },
  watch: {
    params: {
      handler() {
        if (this.autoLoad) {
          this.init();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      // 详情弹出表单设置
      formOption: {
        title: "",
        dialogFormVisible: false,
        dialogSaveBtnVisible: true,
      },
      tableData: [],
      milestonesTypeArray: [],
      milestonesStatusArray: [],
      page: {
        curPage: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  methods: {
    load(params) {
      this.init(params);
    },
    init(params) {
      this.getData(params);
      this.getMilestonesTypeArray();
      this.getMilestonesStatusArray();
    },
    getData(params) {
      this.$api
        .scheduleListApi({
          ...(params || this.params),
          ...this.page,
        })
        .then((res) => {
          this.page.total = res.body.count;
          this.page.curPage = res.body.curPage;
          this.page.pageSize = res.body.pageSize;
          this.tableData = res.body.data;
        });
    },
    confirm(val, val2) {
      this.$confirm(this.$l("tips_sure") || "是否确认？", this.$l("INDEX.tips_question_title") || "提示", {
        confirmButtonText: this.$l("INDEX.tips_confirm") || "确定",
        cancelButtonText: this.$l("INDEX.tips_cancel") || "取消",
        type: "warning",
      }).then(() => {
        this.$api.scheduleConfirmApi({
            scheduleCode: val,
            isChecked: val2,
          })
            .then((res) => {
              this.$message({
                showClose: true,
                message: this.$l("tips_action_ok") || "操作成功！",
                type: "success",
              });
              this.getData();
            });
      });
    },
    delMultiple() {
      let selection = this.$refs.table.selection;
      if (!selection || selection.length < 1) {
        this.$message({
          showClose: true,
          message: "请选择需要删除的数据",
          type: "warning",
        });
        return;
      }
      let tempArray = [];
      selection.forEach((item) => {
        tempArray.push(item.scheduleCode);
      });
      this.delRow(tempArray);
    },
    delRow(scheduleCodeList) {
      this.$confirm(this.$l("tips_delete") || "是否删除？", {
        confirmButtonText: this.$l("INDEX.tips_confirm") || "确认",
        cancelButtonText: this.$l("INDEX.tips_cancel") || "取消",
        type: "warning",
      }).then((_) => {
        this.$api
          .scheduleDelApi({ scheduleCodeList: scheduleCodeList })
          .then((res) => {
            this.$message({
              showClose: true,
              message: this.$l("tips_delete_ok") || "删除成功！",
              type: "success",
            });
            this.getData();
          });
      });
    },
    // 加载表单
    fromLoad(ref, val = {}) {
      const opt = {
        add: this.$l("tips_add") || "新增",
        edit: this.$l("tips_edit") || "编辑",
      };
      // 设置标题
      this.formOption.title = opt[ref];
      this.formOption.dialogSaveBtnVisible = true;
      // 显示表单
      this.formOption.dialogFormVisible = true;
      setTimeout(() => {
        // 调用组件表单加载方法
        this.$refs.form.fromLoad(ref, val);
      }, 0);
    },
    //
    save() {
      this.$refs.form.save();
    },
    saveSuccess() {
      this.getData();
      this.cancel();
    },
    cancel() {
      this.formOption.dialogFormVisible = false;
    },
    sizeChange(val) {
      this.page.curPage = 1;
      this.page.pageSize = val;
      this.getData();
    },
    currentChange(val) {
      this.page.curPage = val;
      this.getData();
    },
    getMilestonesTypeArray() {
      this.$api.systemDict({ dictType: "milestonesType" }).then((res) => {
        this.milestonesTypeArray = res.body.data.map((item) => {
          return {
            text: item.label,
            value: item.value,
          };
        });
      });
    },
    getMilestonesStatusArray() {
      this.$api.systemDict({ dictType: "milestonesStatus" }).then((res) => {
        this.milestonesStatusArray = res.body.data.map((item) => {
          return {
            text: item.label,
            value: item.value,
          };
        });
      });
    },
    filterMilestonesType(value, row) {
      return row.milestonesType === value;
    },
    filterMilestonesStatus(value, row) {
      return row.milestonesStatus === value;
    },
  },
};
</script>
